@if (isLoading | async; as isLoading) {
  <div [ngClass]="navigationState$ | async" class="progress-bar">
    @if (isLoading) {
      <dx-progress-bar id="progress-bar-status" width="100%" [min]="0" [max]="100" [value]="100">
      </dx-progress-bar>
    }
  </div>
}
@if (setupLoaded) {
  <router-outlet></router-outlet>
}

<shared-popup
  [visible]="displayIdleConfirmDialog"
  [panelClass]="'popup w600'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div *appPopupTemplate>
    <div class="app-modal app-modal-simple">
      <div class="app-modal-header">
        <h1 class="fs28 acenter fw500">
          {{ 'message.user_idle_message_title' | translate }}
        </h1>
      </div>
      <div class="app-modal-content acenter text-dark">
        <div class="mb25 fs16">
          <i class="icon-exclamation_line text-warning fs24 vam"></i>
          {{ 'message.user_idle_message_content' | translate }}
        </div>
        <div class="p15 bg-xxlight">
          <div class="fs15">
            {{ 'message.user_idle_message_time_left' | translate }}
          </div>
          <span class="fs30 fw500">{{
            moment
              .utc(
                moment
                  .duration(idleTimeOutLimit, 'seconds')
                  .subtract(userSecondsIdle, 'seconds')
                  .asMilliseconds()
              )
              .format('mm:ss')
          }}</span>
        </div>
      </div>
      <div class="app-modal-footer">
        <div class="buttons-wrapper">
          <a
            href="javascript:void(0)"
            (click)="endIdleTimerAndSession()"
            class="simple-btn simple-btn-rounded simple-btn-text-grey simple-btn-md bigger-side-pads">
            {{ 'actions.sign_out' | translate }}
          </a>
          <a
            href="javascript:void(0)"
            (click)="restartIdleTimer()"
            class="simple-btn simple-btn-rounded simple-btn-accent simple-btn-md bigger-side-pads">
            {{ 'actions.continue' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</shared-popup>

<shared-popup
  [(visible)]="showRefreshPopup"
  [panelClass]="'popup small'"
  [animation]="'scale'"
  [outsideClick]="false">
  <div class="app-modal app-modal-simple">
    <div class="app-modal-header">
      <a
        href="javascript:void(0)"
        class="app-modal-close-icon"
        (click)="showRefreshPopup = false"></a>
    </div>
    <div class="app-modal-content">
      <div class="app-form-panel app-form-panel-simple">
        <div class="app-form-panel-content acenter">
          <div>
            <img
              src="../../../../../assets/images/new_version_available.svg"
              alt=""
              style="width: 324px" />
          </div>
          <h1 class="mt40 mb15 fs28">
            {{ 'general.new_version_available' | translate }}
          </h1>
          <div class="fs15 text-dark">
            {{ 'general.new_version_refresh_text' | translate }}
          </div>
          <a
            href="javascript:void(0)"
            class="mt25 simple-btn simple-btn-xl simple-btn-rounded simple-btn-dark-line simple-btn-shadow bigger-side-pads"
            (click)="updateToLatest()">
            {{ 'actions.refresh' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</shared-popup>
